// extracted by mini-css-extract-plugin
module.exports = {"map":"NavButton_map__358hA","wrapper":"NavButton_wrapper__24liM","frame-bar":"NavButton_frame-bar__2LgtG","focused":"NavButton_focused__1x5Zh","text":"NavButton_text__5AbF4"};